<template>
  <Modal
    :show="show"
    width="large"
    hide-default-actions
    @close="onClose"
  >
    <template #title>
      Add comment
    </template>

    <template #content>
      <div
        v-if="profileTitle"
        class="mb-3"
      >
        <div class="text-body-2 text-textDarkest mb-1">
          {{ profileTitle }}
        </div>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Comments are saved to the job profile editor, so your team can discuss and collaborate on
          edits alongside the document.
        </p>
      </div>
      <div
        v-if="fieldLabel"
        class="text-body-2 text-medium-emphasis mb-2"
      >
        {{ fieldLabel }}
      </div>
      <div
        v-if="fieldLabel || quotedText"
        class="table-cell-quote original-quote"
      >
        {{ quotedText || '—' }}
      </div>

      <div class="mt-8">
        <InlineCommentComposer
          :thread-location="threadLocation"
          :thread-meta-data="threadMetaData"
          :thread-name="profileTitle"
          @close="onClose"
          @message-send="onMessageSend"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { useCommenting } from '@/stores/commenting/commenting';
import Modal from '@/components/shared/Modal.vue';
import InlineCommentComposer from '@/components/document/comments/InlineCommentComposer.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  profileUlid: { type: String, default: '' },
  profileTitle: { type: String, default: '' },
  fieldLabel: { type: String, default: '' },
  quotedText: { type: String, default: '' },
});

const emit = defineEmits(['close']);

const commenting = useCommenting();

const threadLocation = computed(() => ({
  page: 'job-profile-hris-view',
  id: props.profileUlid ? String(props.profileUlid) : '',
}));

const threadMetaData = computed(() => ({
  jobId: props.profileUlid ? String(props.profileUlid) : '',
}));

const onClose = () => {
  emit('close');
};

const onMessageSend = async (event) => {
  const [{ messageId, threadId }] = event.detail;

  await commenting.addQuotedPlainTextToInlineMessage({
    threadId,
    messageId,
    plainText: props.quotedText,
  });

  emit('close');
};
</script>

<style scoped lang="less">
@import '@/less/cord';

.table-cell-quote.original-quote {
  border-left: fade(@grey-900, 20%) solid 1px;
  padding-left: 20px;
  opacity: 0.8;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
